import type React from 'react';
import { createContext, useContext } from 'react';

import type { Skill } from '@coursera-web/program-personalized-tab';

export type EnterpriseOnboardingContextType = {
  enterpriseOnboardingDataLoading: boolean;
  enterpriseLearningGoalMessage?: React.ReactElement;
  enterpriseCompletedOnboarding?: boolean;
  skills: Array<Skill>;
};

const EnterpriseOnboardingContext = createContext<EnterpriseOnboardingContextType>({
  enterpriseOnboardingDataLoading: false,
  enterpriseLearningGoalMessage: undefined,
  enterpriseCompletedOnboarding: undefined,
  skills: [],
});

export const useEnterpriseOnboardingData = () => useContext(EnterpriseOnboardingContext);

export default EnterpriseOnboardingContext;
